import React, {useEffect, useState} from 'react';
import {Button, Stack, Typography} from "@mui/material";
import {Form, Formik} from 'formik';
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {enGB} from 'date-fns/locale'
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import { Item, usePostItemsMutation } from '../../../redux/vmsApi';
import createItemModel, { createItemModelType } from '../models/createItemModel';
import LoadingCover from '../../common/LoadingCover';
import CreateItemForm from '../forms/CreateItemForm';

type MyFormValues = createItemModelType

const createItemModelInitial = createItemModel.initialValues

type Props = {
  onSuccess?: (Item: Item) => void;
};

const CreateItemPage: React.FC<Props> = ({onSuccess}) => {
  const [createItem, {isSuccess, isLoading}] = usePostItemsMutation();
  const [showOverlay, setShowOverlay] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);

  useEffect(() => {
    setShowOverlay(isLoading || isSuccess);
    if (isSuccess) {
      setTimeout(() => {
        setShowOverlay(false)
        setShowSuccessMsg(true)
      }, 3000);
    }
  }, [isLoading, isSuccess]);

  const initialValues: MyFormValues = {
    ...createItemModelInitial,
  };

  

  const handleSubmit = async (values: MyFormValues) => {
   
    const newItem = {
        itemCode: values.itemCode,
        quantityUnit: values.quantityUnit,
        description: values.description, 
        itemCategoryId: values.categoryId, 
        // rate: values.itemCost ,
        inventoryId: values.inventoryId,
        inventoryCode: values.inventoryCode,
        inventoryDescription: values.inventoryDescription,
        categoryCode: values.categoryCode,
        categoryDescription: values.categoryDescription,
        isService: values.isService
    }
    console.log("newItem",newItem);
    setShowOverlay(true)
    try {
      const result = await createItem({newItem}).unwrap();
      setShowOverlay(false);
      
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error:any) {
      
      console.error("Error submitting form:", error?.data.error.message);
    
      if (error) {
        alert(`Failed to submit: ${error?.data.error.message}`);
      } else {
        alert("An unexpected error occurred while submitting the form.");
      }
    }
    
  }

  if (showSuccessMsg) {
    return (
      <Typography>Thank you, your response has been received</Typography>
    )
  }

  return (
    <React.Fragment>
      {showOverlay && <LoadingCover isSuccess={isSuccess}/>}
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={handleSubmit}
        
      >
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
          <Form>
            <Stack spacing={4} width="100%" p={10} pb={5}>
              <CreateItemForm/>
              <Button
                variant="contained"
                type="submit"
              >
                Submit
              </Button>
            </Stack>
          </Form>
        </LocalizationProvider>
      </Formik>
      </React.Fragment>
  )
}

export default CreateItemPage;
